import React from "react";
import { useState } from "react";
import { useLazyGetXMLReportFieldsForMappingQuery } from "../../../../app/services/reportTemplateAPI";
import { useEffect } from "react";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import DataLoader from "../../../../components/molGrid/ui/dataLoader/DataLoader";
import Buttons from "../../../../components/ui/button/Buttons";
import CenterModal from "../../../../components/ui/centerModal/CenterModal";
import MappingSchemaField from "./MappingSchemaField";
import NoRecordFound from "../../../../components/molGrid/ui/noRecordFound/NoRecordFound";
import PropTypes from "prop-types";

const MappingFieldPrimeList = ({
  reportTemplateID,
  xmlTemplateId,
  xmlReportId,
}) => {
  const [dataSource, setDataSource] = useState([]);
  const [isXSDTemplateModelOpen, setIsXSDTemplateModelOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});
  const [isloadingData, setIsloadingData] = useState(true);
  const [selectRow, setSelectrow] = useState("");
  const [data, setData] = useState()

  const [
    getXMLReportFieldsForMapping,
    {
      isLoading: isXmlSchemaReportLoading,
      isFetching: isXmlSchemaReportFetching,
      isSuccess: isXmlSchemaReportSuccess,
      data: XmlSchemaReporttData,
    },
  ] = useLazyGetXMLReportFieldsForMappingQuery();

  useEffect(() => {
    if (xmlReportId) {
      getXMLReportFieldsForMapping(xmlReportId);
    }
  }, [xmlReportId]);

  //  table tree view
  useEffect(() => {
    if (!isXmlSchemaReportFetching && isXmlSchemaReportSuccess) {
      function buildTree(XmlSchemaReporttData, parentId = 0) {
        return XmlSchemaReporttData.filter(
          (item) => item.xmlSchemaFieldParentID === parentId
        ).map((item) => ({
          ...item,
          children: buildTree(XmlSchemaReporttData, item.xmlSchemaField),
        }));
      }
      function flattenTreeWithPrefixes(nodes, level = 0) {
        let result = [];

        nodes.forEach((node) => {
          const spacePrefix = "   ".repeat(level + 1);
          const prefix = level > 0 ? `${spacePrefix}|__` : "";
          result.push({
            ...node,
            displayName: `${prefix}${node.schemaFieldName}`,
          });

          if (node.children && node.children.length > 0) {
            result = result.concat(
              flattenTreeWithPrefixes(node.children, level + 1)
            );
          }
        });
        return result;
      }
      const tree = buildTree(XmlSchemaReporttData, 0);
      const flattened = flattenTreeWithPrefixes(tree);
      setDataSource(flattened.map(({ children, ...item }) => item));
      setIsloadingData(
        isXmlSchemaReportFetching && XmlSchemaReporttData.length < 0
          ? true
          : false
      );
      setData(XmlSchemaReporttData.length > 0)
    }
  }, [
    isXmlSchemaReportFetching,
    isXmlSchemaReportSuccess,
    XmlSchemaReporttData,
  ]);


  const handleCustomColumnButtonClick = (rowData) => {
    setSelectedRow(rowData);
    setIsXSDTemplateModelOpen(true);
  };

  const handleSucces = () => {
    getXMLReportFieldsForMapping(xmlReportId);
    handleCloseModel();
  };

  const handleCloseModel = () => {
    setIsXSDTemplateModelOpen(false);
    setSelectedRow({});
  };

  const handleRowSelect = (rowData) => {
    setSelectrow(rowData);
  };
  return (
    <>
      {isloadingData ? (
        <DataLoader />
      ) : (
        <div className="prime-table-sec mapping-field">
          <div className="card">
            {data > 0 ?
              <DataTable
                value={dataSource}
                selection={selectedRow}
                selectionMode="single"
                stripedRows
                scrollable
                scrollHeight="400px"
                virtualScrollerOptions={{ itemSize: 20 }}
                dataKey="xmlSchemaField"
                tableStyle={{ minWidth: "50rem" }}
                onSelectionChange={(e) => setSelectedRow(e.value)}
                metaKeySelection={true}
              >
                <Column
                  field="xmlSchemaField"
                  header="Id"
                  style={{ width: "auto" }}
                ></Column>
                <Column
                  field="displayName"
                  header="SchemaFieldName"
                  style={{ width: "auto" }}
                ></Column>
                <Column
                  field="schemaFieldType"
                  header="SchemaFieldType"
                  style={{ width: "auto" }}
                ></Column>
                <Column
                  field="valFieldName"
                  header="Assigned Value"
                  style={{ width: "auto" }}
                ></Column>
                <Column
                  field=""
                  header="Assign Value"
                  style={{ width: "auto" }}
                  body={(rowData) =>
                    rowData?.schemaFieldType !== null ? (
                      <div className="custom-col-btn">
                        <Buttons
                          buttonText={
                            rowData?.valFieldName == null
                              ? "Assign Value"
                              : "ReAssign Value"
                          }
                          buttonTypeClassName="btn info-btn"
                          onClick={() => handleCustomColumnButtonClick(rowData)}
                        />
                      </div>
                    ) : null
                  }
                ></Column>
              </DataTable>
              : <NoRecordFound />
            }
          </div>
        </div>
      )}
      <CenterModal
        modalTitle={`Mapping XML Schema Field : ${selectedRow?.schemaFieldName}`}
        modalSize={"w-35"}
        isOpen={isXSDTemplateModelOpen}
        onClose={handleCloseModel}
        transition={"grow"}
      >
        <MappingSchemaField
          selectRow={selectRow}
          reportTemplateID={reportTemplateID}
          xmlTemplateId={xmlTemplateId}
          xmlReportId={xmlReportId}
          selectedRow={selectedRow}
          onSuccess={handleSucces}
          onClose={handleCloseModel}
        />
      </CenterModal>
    </>
  );
};

MappingFieldPrimeList.prototype = {
  reportTemplateID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  xmlTemplateId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

export default MappingFieldPrimeList;
